/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Step1_DescInputs */

const en_keyword_optimizer_step1_desc = /** @type {(inputs: Keyword_Optimizer_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scans your resume against the job description to find which keywords are present, missing, or overused.`)
};

const de_keyword_optimizer_step1_desc = /** @type {(inputs: Keyword_Optimizer_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scannt deinen Lebenslauf gegen die Stellenbeschreibung, um vorhandene, fehlende oder überverwendete Keywords zu finden.`)
};

const fr_keyword_optimizer_step1_desc = /** @type {(inputs: Keyword_Optimizer_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse votre CV par rapport à l'offre d'emploi pour trouver les mots-clés présents, manquants ou surutilisés.`)
};

const es_keyword_optimizer_step1_desc = /** @type {(inputs: Keyword_Optimizer_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escanea tu CV contra la oferta de empleo para encontrar qué palabras clave están presentes, faltan o se usan en exceso.`)
};

const it_keyword_optimizer_step1_desc = /** @type {(inputs: Keyword_Optimizer_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scansiona il tuo CV rispetto all'annuncio di lavoro per trovare quali parole chiave sono presenti, mancanti o sovrautilizzate.`)
};

const nl_keyword_optimizer_step1_desc = /** @type {(inputs: Keyword_Optimizer_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scant je CV tegen de vacature om te vinden welke zoekwoorden aanwezig, ontbrekend of overmatig gebruikt zijn.`)
};

const pl_keyword_optimizer_step1_desc = /** @type {(inputs: Keyword_Optimizer_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skanuje Twoje CV na tle ogłoszenia, by znaleźć obecne, brakujące lub nadużywane słowa kluczowe.`)
};

const fi_keyword_optimizer_step1_desc = /** @type {(inputs: Keyword_Optimizer_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skannaa ansioluettelosi työpaikkailmoitusta vasten ja selvittää, mitkä avainsanat ovat mukana, puuttuvat tai ovat ylikäytettyjä.`)
};

const da_keyword_optimizer_step1_desc = /** @type {(inputs: Keyword_Optimizer_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanner dit CV mod jobopslaget for at finde hvilke nøgleord der er til stede, mangler eller er overbrugt.`)
};

const sv_keyword_optimizer_step1_desc = /** @type {(inputs: Keyword_Optimizer_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skannar ditt CV mot jobbannonsen för att hitta vilka nyckelord som finns, saknas eller överanvänds.`)
};

/**
* | output |
* | --- |
* | "Scans your resume against the job description to find which keywords are present, missing, or overused." |
*
* @param {Keyword_Optimizer_Step1_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_step1_desc = /** @type {((inputs?: Keyword_Optimizer_Step1_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Step1_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_step1_desc(inputs)
	if (locale === "fr") return fr_keyword_optimizer_step1_desc(inputs)
	if (locale === "es") return es_keyword_optimizer_step1_desc(inputs)
	if (locale === "it") return it_keyword_optimizer_step1_desc(inputs)
	if (locale === "nl") return nl_keyword_optimizer_step1_desc(inputs)
	if (locale === "pl") return pl_keyword_optimizer_step1_desc(inputs)
	if (locale === "fi") return fi_keyword_optimizer_step1_desc(inputs)
	if (locale === "da") return da_keyword_optimizer_step1_desc(inputs)
	if (locale === "sv") return sv_keyword_optimizer_step1_desc(inputs)
	return en_keyword_optimizer_step1_desc(inputs)
});